const supportedCfLocales = ['de', 'en', 'nl', 'es'];

const defaultLocale = 'de';

export function getSupportedLocale(requestedLocale) {
    if (supportedCfLocales.indexOf(requestedLocale) !== -1) {
        return requestedLocale;
    }

    return defaultLocale;
}
